export default __webpack_public_path__ + "static/media/cegah (2).5d5eb773.png";